import { GenericApi } from "./generic.api";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ProductCustomer } from "../model/ddb.model";
import { createUrl, queryToParams } from "./api.util";
import { Observable } from "rxjs";
import { IQueryFilter, QueryResult } from "../model/query.filter.class";
import { ICustomerBackorderProductLog } from "../model/customer-backorder-product.model";
// Convenience Type
type T = ProductCustomer;

@Injectable()
export class CustomerProductApi extends GenericApi<T> {
  public path = "product-customer";

  constructor(public httpClient: HttpClient) {
    super(httpClient);
  }

  getAllProductCustomersByProductId = (
    productId: number | string,
  ): Observable<ProductCustomer[]> => {
    return this.httpClient.get<ProductCustomer[]>(
      createUrl(this.path, "getAllProductCustomersByProductId"),
      { params: { productId: productId } },
    );
  };

  submitSubstituteRequest = (payload: {
    id: number;
    substituteProductId: number | null;
    substituteRule: string | null;
    note: string;
    status?: string;
  }): Observable<any> => {
    return this.httpClient.post(
      createUrl(this.path, "create-substitute-product", payload.id),
      payload,
    );
  };

  approveSubstituteAction(
    id: number | string,
    type: string,
    rulee?: string,
    info?: string,
  ): Observable<any> {
    return this.httpClient.post(
      createUrl(this.path, "substitute-action", id),
      {},
      {
        params: {
          type,
          ...(rulee ? { rule: rulee } : {}),
          ...(info ? { info } : {}),
        },
      },
    );
  }

  getSubstituteLogs(
    query: IQueryFilter,
  ): Observable<QueryResult<ICustomerBackorderProductLog>> {
    return this.httpClient.get<QueryResult<ICustomerBackorderProductLog>>(
      createUrl(this.path, "substitute/logs"),
      {
        params: queryToParams(query),
      },
    );
  }

  updateBulkSubstituteproduct(
    data: { id: number | string; status?: string; rule?: string }[],
  ): Observable<any> {
    return this.httpClient.post(
      createUrl(this.path, "updateBulkSubstituteproduct"),
      data,
    );
  }

  bulkSendSubstituteApproval(ids: (number | string)[]): Observable<any> {
    return this.httpClient.post(
      createUrl(this.path, "bulkSendSubstituteApproval"),
      { ids },
    );
  }

  generateSubstituteReport(payload: {
    customerId: string | number;
    id?: (string | number)[];
  }): Observable<{ s3url: string }> {
    return this.httpClient.post<{ s3url: string }>(
      createUrl(this.path, "substitute/report"),
      payload,
    );
  }
}
